import { render } from "./horizontal.vue?vue&type=template&id=ed5c698c"
import script from "./horizontal.vue?vue&type=script&lang=js"
export * from "./horizontal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__